import TreatmentPopoverList from './TreatmentPopoverList';

export default TreatmentPopoverList;
